import KlarnaPaymentContainer from '@activebrands/core-web/containers/KlarnaPaymentContainer';

// Not in use right now
const KlarnaPayment = () => (
    <div>
        <KlarnaPaymentContainer languageTransform={{ svse: 'se' }} />
    </div>
);

export default KlarnaPayment;
